import { EventEmitter, Injectable } from '@angular/core';
import * as signalR from '@aspnet/signalr';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {

  public hubConnection: signalR.HubConnection;
  public onEveryoneNotificationReceiver: EventEmitter<{ user: string, message: string }> = new EventEmitter();

  public async startConnection(kullaniciBuroId: number): Promise<void> {
    const hubUrl = `${environment.API_NOTF_HUB_URL}?buroId=${kullaniciBuroId}`;
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl)
      .build();

    try {
      await this.hubConnection.start();
      console.log('SignalR connection started');
    } catch (err) {
      console.error('SignalR connection error:', err);
    }
  }

  public sendEveryoneNotificationListener(): void {
    this.hubConnection.on('ReceiveMessage', (user, message) => {
      this.onEveryoneNotificationReceiver.emit({ user, message });
    });
  }
}
